import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@app/@shared/components/transaction-view/transaction-view.component';
import { TranslatorService } from '@app/shell/translator.service';
import { TransactionFacadeService } from '@app/transaction/transaction-facade.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-subtransactional-cu-dialog',
  templateUrl: './subtransactional-cu-dialog.component.html',
  styleUrls: ['./subtransactional-cu-dialog.component.scss'],
})
export class SubtransactionalCuDialogComponent implements OnInit {
  labels: any;
  private unSubscribe = new Subject();
  field: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog: DialogData,
    private translator: TranslatorService,
    private transactionFacadeService: TransactionFacadeService
  ) {
    this.detectLanguageChange();
  }

  ngOnInit(): void {
    this.field = this.dialog;
    /* istanbul ignore next */
    this.field = this.field?.data;
  }

  detectLanguageChange() {
    this.translator.languageLables$.pipe(takeUntil(this.unSubscribe)).subscribe((res: any) => {
      this.labels = res;
    });
  }
  upgrade() {
    //this.dialog.close();
    /* istanbul ignore next */
    let triggerCond = {
      triggerContextualID: this.field?.nslAttributeProperties?.triggerSubTransactionContextualId,
    };
    let data = {
      gsiId: Number(sessionStorage.innerGSIid),
      gsiMasterId: Number(sessionStorage.innerGSIid),
    };
    this.transactionFacadeService.saveSubtransaction(triggerCond);
    // this.transactionFacadeService.getListChangeUnitByGSIId(data, false, false, triggerCond
  }
}
